<template>
	<div id="app">
		<div class="loading" v-if="isShowLoading">
			<van-loading />
		</div>

		<!-- 全局阻塞遮罩 -->
		<div class="global-blocking-mask" v-if="isGlobalBlocking">
			<div class="blocking-content">
				<van-loading size="50px" color="#1989fa" />
				<div class="blocking-text">正在初始化，请稍候...</div>
			</div>
		</div>

		<keep-alive v-if="!isGlobalBlocking">
			<router-view v-if="$route.meta.keepAlive" />
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive && !isGlobalBlocking" />
	</div>
</template>

<script>
import { fastLogin, getCytxuserInfo } from "@/api/purse.js";
import { enableGlobalRequestLock, releaseGlobalRequestLock } from "@/http/request.js";

import utils from "@/common/utils.js";
export default {
	name: "App",
	data() {
		return {
			isShowLoading: true,
			isGlobalBlocking: false, // 全局阻塞状态
		};
	},
	methods: {
		/**
		 * 执行阻塞式fastLogin
		 * 在此期间阻塞所有UI交互和页面渲染
		 * @returns {Promise} fastLogin的Promise结果
		 */
		async executeBlockingFastLogin() {
			// 阻塞所有用户交互
			document.body.style.pointerEvents = 'none'
			document.body.style.userSelect = 'none'

			// 阻塞页面滚动
			document.body.style.overflow = 'hidden'

			try {
				// 执行fastLogin并等待完成
				const result = await fastLogin({
					access_token: sessionStorage.getItem("access_token"),
				})
				return result
			} finally {
				// 恢复用户交互
				document.body.style.pointerEvents = 'auto'
				document.body.style.userSelect = 'auto'
				document.body.style.overflow = 'auto'
			}
		},
		/**
	 * 执行阻塞式fastLogin
	 * 在此期间阻塞所有UI交互和页面渲染
	 * @returns {Promise} fastLogin的Promise结果
	 */
		async getCytxuserInfoFun(code) {
			// 阻塞所有用户交互
			document.body.style.pointerEvents = 'none'
			document.body.style.userSelect = 'none'

			// 阻塞页面滚动
			document.body.style.overflow = 'hidden'

			try {
				const result = await getCytxuserInfo({ partner_auth_code: code })
				return result
			} finally {
				// 恢复用户交互
				document.body.style.pointerEvents = 'auto'
				document.body.style.userSelect = 'auto'
				document.body.style.overflow = 'auto'
			}
		}
	},
	async created() {
		setTimeout(() => {
			this.isShowLoading = false;
		}, 500);
		try {
			if (location.href.indexOf("partner_auth_code") > -1) {
				if (typeof window !== 'undefined' && window.__partnerAuthBootstrapping) {
					return
				}
				const url = new URL(window.location.href)
				const code = url.searchParams.get('partner_auth_code')
				const lastCode = sessionStorage.getItem('last_partner_auth_code')
				const existingToken = sessionStorage.getItem('access_token')
				if (code && lastCode === code && existingToken) {
					url.searchParams.delete('partner_auth_code')
					history.replaceState(null, '', url.toString())
					return
				}
				if (code) {
					let res = await this.getCytxuserInfoFun(code)
					sessionStorage.setItem("access_token", res.data.access_token)
					sessionStorage.setItem('last_partner_auth_code', code)
					url.searchParams.delete('partner_auth_code')
					history.replaceState(null, '', url.toString())
					return
				}
			}
			// 兼容创业天下h5
			console.log(location.href, 'location.href')

			if (location.href.indexOf("access_token_yc") > 0) {
				sessionStorage.setItem("access_token", location.href.split("access_token_yc=")[1].split("&")[0]);
				// 启用全局阻塞（UI + 所有接口）
				this.isGlobalBlocking = true
				enableGlobalRequestLock()

				try {
					// 阻塞所有进程直到fastLogin完成
					const res = await this.executeBlockingFastLogin()
					console.log(res, 'fastLogin completed')
					let access_token = res.data.access_token
					let phoneNumber = location.href.split("zqUserPhone=")[1].split("&")[0]

					console.log(access_token, 'access_token')

					sessionStorage.setItem("access_token", access_token);
					sessionStorage.setItem("phoneNumber", phoneNumber);

					console.log(sessionStorage.getItem("access_token"), 'sessionStorage.getItem("access_token")')
				} catch (error) {
					console.error('fastLogin failed:', error)
				} finally {
					// 解除全局阻塞
					releaseGlobalRequestLock()
					this.isGlobalBlocking = false
				}
				return
			}
			// let appData = {
			// 	telephone: '13096977829'
			// }
			let appData = utils.getAppData(); //获取创业天下app传递信息
			// sessionStorage.setItem( "access_token","2ee58a04b524894c743c8cf1807de31e");
			if (appData.access_token) {
				sessionStorage.setItem("access_token", appData.access_token);
				if (appData.type) {
					sessionStorage.setItem("type", appData.type);
				}
				let phoneNumber =
					appData.telephone.substr(0, 3) + "****" + appData.telephone.substr(7);
				sessionStorage.setItem("phoneNumber", phoneNumber);
			}
			console.log('从app获取到参数type:', appData);
			// console.log(appData)
		} catch (err) {
			console.log(err);
			const search = window.location.search
			if (search.indexOf('admin') != -1) {
				let access_token = search.split('access_token=')[1].split('&')[0]
				let phoneNumber = search.split('phoneNumber=')[1].split('&')[0]
				let admin = search.split('admin=')[1].split('&')[0]
				if (admin && access_token && phoneNumber) {
					sessionStorage.setItem("access_token", access_token);
					sessionStorage.setItem("phoneNumber", phoneNumber);
					console.log('admin open', access_token, phoneNumber)
				}
			}
		}
	},
};
</script>

<style>
body,
html {
	width: 100%;
	height: 100%;
	margin: 0;
	padding: 0;
	/* background-color: #F4F6F8; */
	/*背景色修改 */
}

#app {
	width: 100%;
	height: 100%;
	min-height: 100%;
	padding: 0;
	margin: 0;
	/* background-color: #1BC392; */
}

h1,
h2,
h3,
h4,
h5,
h6 {
	margin: 0;
}

.warning-tips {
	padding-top: 50%;
	text-align: center;
}

.loading {
	width: 100px;
	height: 100px;
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	left: calc(50% - 50px);
	top: calc(50% - 50px);
	z-index: 999999999;
}

/* 全局阻塞遮罩样式 */
.global-blocking-mask {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(255, 255, 255, 0.9);
	z-index: 9999999999;
	display: flex;
	justify-content: center;
	align-items: center;
	pointer-events: all;
}

.blocking-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.blocking-text {
	margin-top: 20px;
	font-size: 16px;
	color: #666;
	text-align: center;
}
</style>
